import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import MarketDepthSection from '../components/MarketDepthSection';
import SystemArchitecture from '../components/SystemArchitecture';
import AlertsSection from '../components/AlertsSection';
import FAQSection from '../components/FAQSection';
import AlphaCTA from '../components/AlphaCTA';
import Footer from '../components/Footer';
import { analytics, trackPageView } from '../lib/analytics';

const Home = () => {
  useEffect(() => {
    analytics.landingView();
    trackPageView('home');
  }, []);

  return (
    <div className="min-h-screen bg-[#06070d]">
      <HeroSection />
      <MarketDepthSection />
      <SystemArchitecture />
      <AlertsSection />
      {/* TestimonialsSection removed - unverifiable claims */}
      <FAQSection />
      <AlphaCTA />
      <Footer />
    </div>
  );
};

export default Home;
